<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="bankAccountFormGroup">
    <mat-form-field>
      <mat-label>Bank</mat-label>
      <mat-select required [formControl]="bankFormControl">
        <mat-option *ngFor="let bank of banks" [value]="bank.name">
          {{bank.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Bank')" class="info-icon">help_outline</mat-icon>

    <br>
    
    <mat-form-field>
      <mat-label>Branch Number</mat-label>
      <input required [formControl]="branchRoutingNumberFormControl" type="text" matInput>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Branch Number')" class="info-icon">help_outline</mat-icon>
    
    <br>

    <mat-form-field>
      <mat-label>Account Type</mat-label>
      <mat-select required [formControl]="bankAccountTypeFormControl">
        <mat-option *ngFor="let type of bankAccountTypes" [value]="type.name">
          {{type.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Currency')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Account Name</mat-label>
      <input required [formControl]="nameFormControl" type="text" matInput>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Account Name')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Account Number</mat-label>
      <input required [formControl]="accountNumberFormControl" type="text" matInput>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Account Number')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>IBAN Number</mat-label>
      <input [formControl]="ibanNumberFormControl" type="number" matInput>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('IBAN Number')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Currency</mat-label>
      <mat-select required [formControl]="currencyFormControl">
        <mat-option *ngFor="let currency of currencies" [value]="currency.name">
          {{currency.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Currency')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Location of Bank</mat-label>
      <input matInput type="text"
             [placeholder]="getInfoTooltip('Location of Bank')"
             [formControl]="locationFormControl"
             (input)="locationTextChanged$.next($any($event.target).value)"
             [matAutocomplete]="locationFormControlAuto">
      <mat-autocomplete #locationFormControlAuto="matAutocomplete" [panelWidth]="'40vw'">
        <mat-option (onSelectionChange)="locationSelected($event.source.value)"
                    *ngFor="let location of filteredLocations"
                    [value]="getLocationDisplayString(location)">
          {{getLocationDisplayString(location)}}
        </mat-option>
      </mat-autocomplete>
      <button *ngIf="locationFormControl.value" aria-label="Clear"
              mat-button mat-icon-button matSuffix
              (click)="clearLocation()">
        <mat-icon style="color: grey;">clear</mat-icon>
      </button>
    </mat-form-field>
    <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Location of Death')">
      help_outline
    </mat-icon>


  </form>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button (click)="onCancelClick()" color="warn">Cancel</button>
  <button class="dialog-button" mat-raised-button
          [disabled]="!bankAccountFormGroup.valid"
          (click)="onSaveClick()" color="primary">{{deferSave() ? 'Okay' : 'Save'}}</button>
</mat-dialog-actions>
